import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/services/base.service';
import { AuthenticationService } from '../services/authentication.service';
import { Constants } from '../app.const';
import { UtilService } from '../services/util.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-audit-log',
  templateUrl: './audit-log.component.html',
  styleUrls: ['./audit-log.component.css']
})
export class AuditLogComponent implements OnInit {
  public tableData = [];
  public data: any;
  public tableDataOriginal = [];
  public p: number;
  public nameSelected = true;
  public sourceSelected = true;
  public entityNameSelected = true;
  public timeSelected = true;
  public timeStamp = Constants.timeStamp;
  public userTable = [];
  public dsTable = [];
  public timeTable = [];
  public order = '';
  public userasc = true;
  public sourceasc = true;
  public entityasc = true;
  public timeasc = true;
  public isLoading: boolean;
  public selectedSource = [];
  selectedUserData: any;
  selectedDatasourceData: any;
  selectedTimestampData: any;
  public userDetails: object;

  constructor(
    private httpClient: HttpClient,
    public datepipe: DatePipe,
    public authentication: AuthenticationService,
    public router: Router,
    public baseService: BaseService,
    public utilService: UtilService) { }

  ngOnInit() {
    this.userDetails = {
      userEmail: this.authentication.userEmail,
      userID: this.authentication.userId,
      userName: this.authentication.userName
    };
    const baseUrl = environment.apiUrl;
    this.isLoading = true;

    this.httpClient.get<any>(baseUrl + 'audit_investigate?userDetail=' + encodeURIComponent(JSON.stringify(this.userDetails)))
      .pipe(finalize(() => this.isLoading = false))
      .subscribe((data) => {
        this.data = data;
        this.tableData = data.all_records;
        let count = 1;
        this.tableData.filter((property) => {
          property.uniqueId = count++;
        });
        this.tableDataOriginal = JSON.parse(JSON.stringify(this.tableData));
        this.userTable = this.timeTable = this.dsTable = this.tableDataOriginal;
        this.isLoading = false;
        this.timeSorting(false);
      });
  }
  userNameSorting(selected) {
    this.userasc = selected ? false : true;
    this.utilService.sortColumn(this.utilService.getSortingOrder(selected), 'name', this.tableData);
    this.nameSelected = !this.nameSelected;
  }
  sorceSorting(selected) {
    this.sourceasc = selected ? false : true;
    this.utilService.sortColumn(this.utilService.getSortingOrder(selected), 'dataSource', this.tableData);
    this.sourceSelected = !this.sourceSelected;
  }
  entityNameSorting(selected) {
    this.entityasc = selected ? false : true;
    this.utilService.sortColumn(this.utilService.getSortingOrder(selected), 'entityName', this.tableData);
    this.entityNameSelected = !this.entityNameSelected;
  }
  timeSorting(selected) {
    this.timeasc = selected ? false : true;
    this.utilService.sortColumn(this.utilService.getSortingOrder(selected), 'timeStamp', this.tableData);
    this.timeSelected = !this.timeSelected;
  }
  selectedUser(value) {
    this.selectedUserData = value;
    this.filter();
  }
  selectedDatasource(value) {
    this.selectedDatasourceData = value;
    this.filter();
  }
  filter() {
    this.p = 1;
    let combinedFilterData = this.tableDataOriginal;

    if (this.selectedUserData && this.selectedUserData !== '') {
      combinedFilterData = this.getCombinationalFilterValue(combinedFilterData, 'name', this.selectedUserData);
    }
    if (this.selectedDatasourceData && this.selectedDatasourceData !== '') {
      combinedFilterData = this.getCombinationalFilterValue(combinedFilterData, 'dataSource', this.selectedDatasourceData);
    }
    if (this.selectedTimestampData && this.selectedTimestampData !== '') {
      combinedFilterData = this.getCombinationalFilterValue(combinedFilterData, 'timeStamp', this.selectedTimestampData);
    }
    this.tableData = combinedFilterData;
  }
  getCombinationalFilterValue(combinedFilterData, searchKey, value) {
    let selectedSource = [];
    if (combinedFilterData.length > 0) {
      if (value && value.target.value == 'All') {
        selectedSource = combinedFilterData;
      } else if (searchKey == 'timeStamp') {
        let startDate;
        let endDate: any = new Date().getTime();
        endDate = this.utilService.convertDateTimeStringIntoNumber(endDate);
        this.tableData = JSON.parse(JSON.stringify(this.tableDataOriginal));
        if (value.target.value === 'Current Month') {
          let dt: any = new Date();
          dt = new Date(dt.getFullYear(), dt.getMonth(), 1).getTime();
          startDate = this.utilService.convertDateTimeStringIntoNumber(dt);
        } else if (value.target.value === 'Last Three Month') {
          const dt: any = new Date();
          dt.setMonth(dt.getMonth() - 3);
          dt.getTime();
          startDate = this.utilService.convertDateTimeStringIntoNumber(dt);
        } else if (value.target.value === 'Last Six Month') {
          const dt: any = new Date();
          dt.setMonth(dt.getMonth() - 6);
          dt.getTime();
          startDate = this.utilService.convertDateTimeStringIntoNumber(dt);
        }
        combinedFilterData.filter(data => {
          const timeStamp = this.utilService.convertDateTimeStringIntoNumber(data.timeStamp);
          if (timeStamp >= startDate && timeStamp <= endDate) {
            selectedSource.push(data);
          }
        });
      } else if (searchKey == 'dataSource') {
        combinedFilterData.filter((ele) => {
          if (ele[searchKey].includes(value.target.value)) {
            selectedSource.push(ele);
          }
        });
      } else {
        combinedFilterData.filter((ele) => {
          if (ele[searchKey] === value.target.value) {
            selectedSource.push(ele);
          }
        });
      }
    }
    combinedFilterData = selectedSource;
    return combinedFilterData;
  }
  selectedTime(value) {
    this.selectedTimestampData = value;
    this.filter();
  }
  // onClick(entity) {
  //   const encodeParam =  encodeURIComponent(btoa(entity.entityName));
  //   this.router.navigate([]).then(result => { window.open( `/home/investigate;id=${entity.entityId};name=${encodeParam};option=${'All'}`, '_blank'); });
  //   }
}
